interface IconProps {
    size?: number;
}

export default function GeminiIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
            <path
                d="M14 0C14 7.732 7.732 14 0 14C7.732 14 14 20.268 14 28C14 20.268 20.268 14 28 14C20.268 14 14 7.732 14 0Z"
                fill="#4285F4"
            />
        </svg>
    );
}
